import PageShell, { PageIntro, Prose } from "@/components/PageShell";

const OFFICES = [
    ["Head Office.", "64 Ivo Whitton Circuit, Kambah ACT 2902."],
    ["Brisbane.", "Level 17, 300 Adelaide Street, Brisbane QLD 4000."],
    ["Perth.", "Suite C, Level 13, 251 Adelaide Terrace, Perth WA 6000."],
];

export function About() {
    return (
        <PageShell testId="about-page">
            <PageIntro eyebrow="About" title="About PayMe" lead="An Australian, family owned and operated, veteran owned payroll company." />
            <Prose>
                <p>PayMe Australia Pty Ltd (ABN 80 130 125 334) provides outsourced payroll for workers placed through recruitment and labour hire companies, with a focus on IT and government contractors.</p>
                <h2>Our Offices</h2>
                <ul>{OFFICES.map(([k, v]) => <li key={k}><strong>{k}</strong> {v}</li>)}</ul>
            </Prose>
        </PageShell>
    );
}

export function ContactUs() {
    return (
        <PageShell testId="contact-page">
            <PageIntro eyebrow="Contact" title="Contact Us" />
            <Prose>
                <ul>
                    <li><strong>Phone.</strong> <a href="tel:1800082006">1800 082 006</a></li>
                    <li><strong>International.</strong> <a href="tel:+61261517000">+61 2 6151 7000</a></li>
                    <li><strong>Enquiries.</strong> <a href="mailto:enquiries@payme.com.au">enquiries@payme.com.au</a></li>
                    <li><strong>Timesheets.</strong> <a href="mailto:timesheets@payme.com.au">timesheets@payme.com.au</a></li>
                </ul>
                <h2>Offices</h2>
                <ul>{OFFICES.map(([k, v]) => <li key={k}><strong>{k}</strong> {v}</li>)}</ul>
            </Prose>
        </PageShell>
    );
}

export function Superannuation() {
    return (
        <PageShell testId="super-page">
            <PageIntro eyebrow="Contractors" title="Superannuation: All You Need to Know" lead="A plain English summary for workers paid through PayMe" />
            <Prose>
                <h2>You are an employee, not a contractor</h2>
                <p>People placed at a client site by a recruitment company are often called "contractors". In fact, you are an employee of the recruitment company, and your super is already included in your contracted rate.</p>
                <h2>The one rule to remember</h2>
                <p>Your super is 12% of your pay, so your contracted rate is made up of <strong>112 equal parts</strong>: 100 parts of pay and 12 parts of super. The quick way to split any rate is to divide it by 1.12. What you get is your pay, and whatever is left is your super.</p>
                <h2>An example at $100 an hour</h2>
                <table className="mt-4 w-full max-w-md overflow-hidden rounded-lg border border-border text-lg" data-testid="super-example-table">
                    <thead><tr className="bg-surface-2"><th colSpan={2} className="px-4 py-2 text-left font-display text-primary">$100 an hour</th></tr></thead>
                    <tbody className="divide-y divide-border">
                        <tr><td className="px-4 py-2 font-bold">$89.29</td><td className="px-4 py-2">your pay (100 parts)</td></tr>
                        <tr><td className="px-4 py-2 font-bold">$10.71</td><td className="px-4 py-2">super (12 parts)</td></tr>
                        <tr><td className="px-4 py-2 font-bold">$100.00</td><td className="px-4 py-2">your contracted rate (112 parts)</td></tr>
                    </tbody>
                </table>
                <p><strong>Check it:</strong> 12% of $89.29 is $10.71, and $89.29 plus $10.71 is exactly $100.</p>
                <h2>When your super is paid</h2>
                <p>PayMe pays your super into your chosen fund every payday, in line with the Payday Super rules that started on 1 July 2026.</p>
                <p><strong>Questions? Call <a href="tel:1800082006">1800 082 006</a> or email <a href="mailto:enquiries@payme.com.au">enquiries@payme.com.au</a>.</strong></p>
            </Prose>
        </PageShell>
    );
}

export function Services() {
    return (
        <PageShell testId="services-page">
            <PageIntro eyebrow="Services" title="Our Services" />
            <Prose>
                <ul>
                    <li><strong>Contractor Payroll.</strong> Payroll for contractors placed through recruitment companies.</li>
                    <li><strong>Salary Packaging.</strong> Package part of your pay before tax.</li>
                    <li><strong>Novated Leasing.</strong> <a href="/#leasing">Fee free novated leasing</a> through our sister company Alliance Leasing.</li>
                    <li><strong>Superannuation.</strong> <a href="/superannuation">Super for contractors</a>, including salary sacrifice.</li>
                    <li><strong>BankIT.</strong> Set aside pay for time off.</li>
                    <li><strong>Recruitment Companies.</strong> <a href="/recruitment-company">Payroll support</a> for your contractors.</li>
                </ul>
            </Prose>
        </PageShell>
    );
}

export function RecruitmentCompany() {
    return (
        <PageShell testId="recruiters-page">
            <PageIntro eyebrow="Recruitment Companies" title="Payroll for Recruitment Companies" lead="Hand your contractor payroll to an Australian, family owned team." />
            <Prose>
                <p>Your contractors remain your employees. PayMe administers their payroll.</p>
                <p className="italic text-muted-foreground">[TO CONFIRM: expanded recruitment company content]</p>
                <p>Talk to us on <a href="tel:1800082006">1800 082 006</a> or <a href="mailto:enquiries@payme.com.au">enquiries@payme.com.au</a>.</p>
            </Prose>
        </PageShell>
    );
}

export function Policy({ title }) {
    return (
        <PageShell testId="policy-page">
            <PageIntro eyebrow="Legal" title={title} />
            <Prose>
                <p className="italic text-muted-foreground">[TO CONFIRM: {title} content]</p>
                <p>Questions? Contact <a href="mailto:enquiries@payme.com.au">enquiries@payme.com.au</a>.</p>
            </Prose>
        </PageShell>
    );
}
